<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <base-material-card color="primary">
          <template v-slot:heading>
            <h2 class="h1 font-weight-light text_google">
              <v-icon large left>mdi-file-send</v-icon>
              การย้ายสายงานบริหารสถานศึกษา
            </h2>
          </template>

          <!-- ══════════════════════════════════════════════════════════════
               BANNER: แสดงสถานะระบบ (period / file window)
               ══════════════════════════════════════════════════════════════ -->
          <v-alert
            v-if="periodStatus"
            :type="systemStatusBannerType"
            outlined
            dense
            class="mb-3"
          >
            <v-row align="center" no-gutters>
              <v-col>
                <span v-if="periodStatus.period_open">
                  <v-icon small left color="green">mdi-check-circle</v-icon>
                  <strong>ระบบยื่นย้ายเปิดอยู่</strong>
                  — ปิดรับ {{ periodStatus.period_stop | thaiDate }}
                </span>
                <span v-else>
                  <v-icon small left color="orange">mdi-lock-clock</v-icon>
                  <strong>ระบบปิดรับการยื่นย้ายแล้ว</strong>
                  (ปิดเมื่อ {{ periodStatus.period_stop | thaiDate }})
                </span>
                <span class="ml-4" v-if="periodStatus.file_open">
                  <v-icon small left color="blue">mdi-paperclip</v-icon>
                  ยังแนบไฟล์ได้ถึง
                  {{ periodStatus.period_stop_file | thaiDate }}
                </span>
                <span class="ml-4" v-else>
                  <v-icon small left color="red">mdi-paperclip-off</v-icon>
                  หมดเวลาแนบไฟล์แล้ว
                </span>
              </v-col>
            </v-row>
          </v-alert>

          <!-- ══════════════════════════════════════════════════════════════
               ZONE A: รายการ Confirm แล้ว (แสดงแทน stepper)
               ══════════════════════════════════════════════════════════════ -->
          <template
            v-if="
              (transference_manages.manage_status_save === 'Save' ||
                transference_manages.manage_status_save === 'Confirm') &&
                transference_manages.manage_cancel_status !== 'cancel'
            "
          >
            <v-card class="mb-4">
              <v-alert type="success" outlined prominent>
                <v-row align="center">
                  <v-col class="grow">
                    <h3>
                      <v-icon left color="green">mdi-check-circle</v-icon>
                      ท่านได้ยืนยันรายการแล้ว — รหัสอ้างอิง:
                      <strong>{{ manage_id_ref }}</strong>
                    </h3>

                    <!-- ─── ไฟล์แนบ ──────────────────────────── -->
                    <div
                      v-if="transference_manages.manage_file_attachment"
                      class="mt-2"
                    >
                      <v-chip color="green" dark small class="mr-2">
                        <v-icon left small>mdi-check</v-icon> มีไฟล์แนบ
                      </v-chip>
                      {{ transference_manages.manage_file_attachment }}
                      <span class="caption ml-2"
                        >(แนบเมื่อ
                        {{
                          transference_manages.manage_file_attachment_date
                        }})</span
                      >
                      <br />
                      <v-btn
                        color="primary"
                        rounded
                        dark
                        small
                        class="mt-1"
                        @click="
                          previewFile(
                            transference_manages.manage_file_attachment
                          )
                        "
                      >
                        <v-icon left small>mdi-eye</v-icon> ดูไฟล์แนบ
                      </v-btn>
                    </div>
                    <div v-else class="mt-2">
                      <v-chip
                        color="orange"
                        dark
                        small
                        v-if="periodStatus && periodStatus.file_open"
                      >
                        <v-icon left small>mdi-alert</v-icon>
                        ยังไม่ได้แนบไฟล์ — กรุณาแนบด้วย
                      </v-chip>
                      <v-chip color="red" dark small v-else>
                        <v-icon left small>mdi-close</v-icon>
                        หมดเวลาแนบไฟล์แล้ว
                      </v-chip>
                    </div>
                  </v-col>

                  <!-- ─── ปุ่มพิมพ์ (พิมพ์ได้เสมอ) ──────────── -->
                  <v-col class="shrink">
                    <v-btn
                      color="blue darken-2"
                      large
                      rounded
                      dark
                      class="mb-2 d-block"
                      @click="openPrintDialog()"
                    >
                      <v-icon left>mdi-printer</v-icon> พิมพ์แบบคำร้อง
                    </v-btn>

                    <!-- ─── ปุ่มแนบไฟล์ (แสดงเมื่อ file_open) ── -->
                    <v-btn
                      color="indigo"
                      large
                      rounded
                      dark
                      class="mb-2 d-block"
                      v-if="periodStatus && periodStatus.file_open"
                      @click="showFileUploadPanel = !showFileUploadPanel"
                    >
                      <v-icon left>mdi-paperclip</v-icon>
                      {{
                        transference_manages.manage_file_attachment
                          ? "เปลี่ยนไฟล์แนบ"
                          : "แนบไฟล์แบบคำร้อง"
                      }}
                    </v-btn>

                    <!-- ─── ปุ่มแก้ไข/รีเซ็ต (เฉพาะ period_open) ── -->
                    <v-btn
                      color="warning"
                      large
                      rounded
                      dark
                      class="d-block"
                      @click="showCancelDialog()"
                      :disabled="!isPeriodOpen"
                    >
                      <v-icon left>mdi-backup-restore</v-icon> ขอแก้ไขรายการ
                    </v-btn>
                    <div v-if="!isPeriodOpen" class="mt-1 text-center">
                      <v-chip color="red" dark x-small>
                        <v-icon left x-small>mdi-clock-alert</v-icon>
                        หมดเวลายื่น แก้ไขไม่ได้
                      </v-chip>
                    </div>
                  </v-col>
                </v-row>
              </v-alert>

              <!-- ─── Panel อัปโหลดไฟล์ (inline) ──────────────── -->
              <v-expand-transition>
                <v-card
                  v-if="
                    showFileUploadPanel &&
                      periodStatus &&
                      periodStatus.file_open
                  "
                  class="mx-4 mb-4 pa-4"
                  outlined
                  color="indigo lighten-5"
                >
                  <v-card-title class="subtitle-1 indigo--text">
                    <v-icon left color="indigo">mdi-paperclip</v-icon>
                    อัปโหลดไฟล์แบบคำร้อง
                    <v-chip color="orange" dark x-small class="ml-2">
                      แนบได้ถึง {{ periodStatus.period_stop_file | thaiDate }}
                    </v-chip>
                  </v-card-title>
                  <v-row>
                    <v-col cols="12">
                      <v-alert type="info" outlined dense>
                        รองรับ PDF, JPG, PNG ขนาดไม่เกิน 10 MB
                      </v-alert>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-file-input
                        v-model="fileAttachment"
                        label="เลือกไฟล์แบบคำร้อง"
                        outlined
                        accept=".pdf,.jpg,.jpeg,.png"
                        prepend-icon="mdi-paperclip"
                        show-size
                        dense
                      ></v-file-input>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex align-center">
                      <v-btn
                        color="indigo"
                        dark
                        :loading="uploading"
                        :disabled="!fileAttachment"
                        @click="uploadFileAttachment()"
                        block
                      >
                        <v-icon left>mdi-upload</v-icon> อัปโหลด
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card>
              </v-expand-transition>
            </v-card>
          </template>

          <!-- ══════════════════════════════════════════════════════════════
               ZONE B: รายการถูกยกเลิก
               ══════════════════════════════════════════════════════════════ -->
          <v-card
            class="mb-4"
            v-if="transference_manages.manage_cancel_status === 'cancel'"
          >
            <v-alert type="error" outlined prominent>
              <h3>
                <v-icon left color="red">mdi-cancel</v-icon>
                รายการนี้ถูกยกเลิกแล้ว
              </h3>
              <p>เหตุผล: {{ transference_manages.manage_cancel_reason }}</p>
              <p>
                วันที่ยกเลิก: {{ transference_manages.manage_cancel_datetime }}
              </p>
              <v-btn
                v-if="periodStatus && periodStatus.period_open"
                color="primary"
                rounded
                @click="resetAndStartNew()"
              >
                <v-icon left>mdi-refresh</v-icon> ทำรายการใหม่
              </v-btn>
            </v-alert>
          </v-card>

          <!-- ══════════════════════════════════════════════════════════════
               ZONE C: Stepper ยื่นรายการ (แสดงเมื่อยังไม่ Save/Confirm)
               ══════════════════════════════════════════════════════════════ -->
          <v-card
            v-if="
              transference_manages.manage_status_save !== 'Save' &&
                transference_manages.manage_status_save !== 'Confirm' &&
                transference_manages.manage_cancel_status !== 'cancel'
            "
          >
            <!-- ─── ตรวจสอบ period_open ก่อนแสดง stepper ─────── -->
            <v-alert
              v-if="periodStatus && !periodStatus.period_open"
              type="error"
              prominent
              class="ma-4"
            >
              <h3>ระบบปิดรับการยื่นย้ายแล้ว</h3>
              <p>ไม่สามารถยื่นรายการใหม่ได้ในขณะนี้</p>
            </v-alert>

            <v-stepper
              v-model="steps"
              vertical
              v-if="periodStatus && periodStatus.period_open"
            >
              <!-- ══════ STEP 1: ข้อมูลเบื้องต้น ══════ -->
              <v-stepper-step :complete="steps > 1" step="1">
                <div>
                  ข้อมูลเบื้องต้น — รหัสรายการ {{ manage_id_ref }}
                  <v-btn
                    icon
                    small
                    color="secondary"
                    @click="previewReportShow()"
                  >
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>
                </div>
              </v-stepper-step>
              <v-stepper-content step="1">
                <v-card>
                  <v-row no-gutters>
                    <v-col cols="12" sm="6">
                      <v-alert
                        border="left"
                        colored-border
                        color="green darken-1"
                        elevation="2"
                        type="info"
                      >
                        <h2>
                          {{ user.title_s }}{{ user.frist_name }}
                          {{ user.last_name }}
                        </h2>
                        <h3>รหัสบัตรประชาชน: {{ user.id_card }}</h3>
                        <h3>เลขที่ตำแหน่ง: {{ user.id_position }}</h3>
                        <h3>วิทยฐานะ: {{ user.rang_name }}</h3>
                        <h3>สังกัด: {{ user.college_name }}</h3>
                        <h3>เงินเดือน: {{ user.salary_s }} บาท</h3>
                        <h3>
                          เกิดวันที่: {{ user.brith_day }} เดือน
                          {{ user.brith_month }} พ.ศ. {{ user.brith_year }}
                        </h3>
                        <h3>อายุ: {{ get_Age }}</h3>
                        <hr />
                        <h3>วันที่บรรจุ: {{ date_appoin_ch || "-" }}</h3>
                        <h3>ระยะเวลาราชการ: {{ get_gov_Age }}</h3>
                        <h3>สถานะภาพ: {{ marital_status }}</h3>
                      </v-alert>
                    </v-col>
                    <v-col cols="12" sm="6" align="center">
                      <v-alert
                        border="left"
                        colored-border
                        color="green darken-1"
                        elevation="2"
                        type="info"
                      >
                        <h2>ปีงบประมาณ: {{ periods.period_year }}</h2>
                        <h3>เขียนที่: {{ user.college_name }}</h3>
                        <h3>วันที่ยื่น: {{ date_today }}</h3>
                        <h3>{{ get_gov_Age_year }}</h3>
                        <hr />
                        <div v-if="!user.date_app_now">
                          <v-alert type="error" prominent>
                            ให้งานบุคลากรดำเนินการวันที่ปฏิบัติงาน ณ
                            สถานศึกษาปัจจุบัน
                          </v-alert>
                        </div>
                        <div v-else>
                          <h3>
                            วันที่เริ่มปฏิบัติหน้าที่ปัจจุบัน:
                            {{
                              user.date_app_now
                                | moment("add", "543 years")
                                | moment("D MMMM YYYY")
                            }}
                          </h3>
                          <h2>ปฏิบัติหน้าที่: {{ get_Appoint_Age }}</h2>
                          {{ localTime }}
                        </div>
                      </v-alert>
                    </v-col>
                    <v-col cols="12">
                      <v-alert
                        border="left"
                        colored-border
                        type="error"
                        elevation="2"
                        v-if="!user.tel_p"
                      >
                        <h2 class="red--text">
                          กรุณาปรับปรุงข้อมูลติดต่อ
                          <v-btn color="red" rounded dark to="/UserProfile">
                            <v-icon>mdi-account-circle</v-icon> ข้อมูลผู้ใช้
                          </v-btn>
                        </h2>
                      </v-alert>
                      <v-alert
                        border="left"
                        colored-border
                        type="error"
                        elevation="2"
                        v-if="
                          personnel_work_history_check.count_work === '0' ||
                            personnel_work_history_check.count_work === 0
                        "
                      >
                        <h2 class="red--text">
                          กรุณาบันทึกประวัติการรับราชการ
                          <v-btn
                            color="red"
                            rounded
                            dark
                            to="/personnel_work_history"
                          >
                            <v-icon>mdi-account-circle</v-icon>
                            ประวัติการรับราชการ
                          </v-btn>
                        </h2>
                      </v-alert>
                      <v-alert
                        border="left"
                        colored-border
                        color="green darken-1"
                        elevation="2"
                        type="info"
                      >
                        <v-card
                          v-if="
                            personnel_education_check.count_ed === '0' ||
                              personnel_education_check.count_ed === 0
                          "
                        >
                          <v-alert type="error" prominent>
                            <v-row align="center">
                              <v-col class="grow"
                                ><h2>บันทึกข้อมูลคุณวุฒิการศึกษา</h2></v-col
                              >
                              <v-col class="shrink">
                                <v-btn
                                  large
                                  rounded
                                  dark
                                  to="/personnel_education"
                                >
                                  <v-icon>mdi-school</v-icon> วุฒิการศึกษา
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-alert>
                        </v-card>
                        <v-card v-else>
                          <v-card-title
                            ><v-avatar size="56"
                              ><v-icon large left
                                >mdi-cast-education</v-icon
                              ></v-avatar
                            >
                            <p class="ml-3">ประวัติการศึกษา</p></v-card-title
                          >
                          <v-card-text>
                            <v-timeline align-top dense>
                              <v-timeline-item
                                v-for="item in personnel_educations"
                                :key="item.id_red"
                                small
                              >
                                <div>
                                  {{ item.education_level }} คณะ:
                                  {{ item.faculty_name }} สาขา:
                                  {{ item.branch_name }} ปีจบ:
                                  {{ item.year_finish }}
                                </div>
                              </v-timeline-item>
                            </v-timeline>
                          </v-card-text>
                        </v-card>
                      </v-alert>
                    </v-col>
                  </v-row>
                </v-card>
                <v-btn @click="addtransference_manageSubmit(1)" color="primary"
                  >ดำเนินการ</v-btn
                >
              </v-stepper-content>

              <!-- ══════ STEP 2: ความรู้ความสามารถ ══════ -->
              <v-stepper-step :complete="steps > 2" step="2">
                ความรู้ความสามารถในการพัฒนาสถานศึกษา
              </v-stepper-step>
              <v-stepper-content step="2">
                <v-card>
                  <v-textarea
                    v-model="transference_manages.manage_knowledge"
                    outlined
                    label="ความรู้ความสามารถ *"
                    rows="4"
                  ></v-textarea>
                </v-card>
                <v-btn
                  @click="updatetransference_manageSubmit(2)"
                  color="primary"
                  >บันทึก</v-btn
                >
                <v-btn text @click="canceltransference(2)">ยกเลิก</v-btn>
              </v-stepper-content>

              <!-- ══════ STEP 3: ประสบการณ์ ══════ -->
              <v-stepper-step :complete="steps > 3" step="3"
                >ประสบการณ์</v-stepper-step
              >
              <v-stepper-content step="3">
                <v-card>
                  <v-textarea
                    v-model="transference_manages.manage_experience"
                    outlined
                    label="ประสบการณ์ *"
                    rows="4"
                  ></v-textarea>
                </v-card>
                <v-btn
                  @click="updatetransference_manageSubmit(3)"
                  color="primary"
                  >บันทึก</v-btn
                >
                <v-btn text @click="canceltransference(1)">ยกเลิก</v-btn>
              </v-stepper-content>

              <!-- ══════ STEP 4: ข้อมูลคู่สมรส ══════ -->
              <v-stepper-step :complete="steps > 4" step="4"
                >ข้อมูลคู่สมรส</v-stepper-step
              >
              <v-stepper-content step="4">
                <v-card>
                  <v-row>
                    <v-col cols="12" md="4"
                      ><v-text-field
                        outlined
                        v-model="transference_manages.manage_spouse"
                        label="คู่สมรสชื่อ"
                      ></v-text-field
                    ></v-col>
                    <v-col cols="12" md="4"
                      ><v-text-field
                        outlined
                        v-model="transference_manages.manage_spouse_occupation"
                        label="อาชีพคู่สมรส"
                      ></v-text-field
                    ></v-col>
                    <v-col cols="12" md="4"
                      ><v-text-field
                        outlined
                        v-model="transference_manages.manage_spouse_location"
                        label="สถานที่ประกอบอาชีพ"
                      ></v-text-field
                    ></v-col>
                    <v-col cols="12" md="4">
                      <v-autocomplete
                        outlined
                        v-model="transference_manages.manage_domicile"
                        :items="provices_sh"
                        item-text="province_name"
                        item-value="province_ID"
                        label="ภูมิลำเนาของข้าพเจ้า จังหวัด"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-autocomplete
                        outlined
                        v-model="transference_manages.manage_spouse_domicile"
                        :items="provices_sh"
                        item-text="province_name"
                        item-value="province_ID"
                        label="ภูมิลำเนาคู่สมรส จังหวัด"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-card>
                <v-btn
                  @click="updatetransference_manageSubmit(4)"
                  color="primary"
                  >บันทึก</v-btn
                >
                <v-btn text @click="canceltransference(1)">ยกเลิก</v-btn>
              </v-stepper-content>

              <!-- ══════ STEP 5: ที่อยู่ปัจจุบัน ══════ -->
              <v-stepper-step :complete="steps > 5" step="5"
                >ข้อมูลที่อยู่ปัจจุบัน</v-stepper-step
              >
              <v-stepper-content step="5">
                <v-card class="pa-2">
                  <v-textarea
                    rows="2"
                    outlined
                    v-model="transference_manages.manage_address_now"
                    label="ที่อยู่ปัจจุบัน *"
                  ></v-textarea>
                </v-card>
                <v-btn
                  @click="updatetransference_manageSubmit(5)"
                  color="primary"
                  >บันทึก</v-btn
                >
                <v-btn text @click="canceltransference(3)">ยกเลิก</v-btn>
              </v-stepper-content>

              <!-- ══════ STEP 6: ที่อยู่เมื่อย้ายแล้ว ══════ -->
              <v-stepper-step :complete="steps > 6" step="6"
                >ข้อมูลที่อยู่เมื่อได้ย้ายแล้ว</v-stepper-step
              >
              <v-stepper-content step="6">
                <v-card>
                  <v-textarea
                    rows="2"
                    outlined
                    v-model="transference_manages.manage_after_move"
                    label="ที่อยู่เมื่อย้ายแล้ว *"
                  ></v-textarea>
                </v-card>
                <v-btn
                  @click="updatetransference_manageSubmit(6)"
                  color="primary"
                  >บันทึก</v-btn
                >
                <v-btn text @click="canceltransference(4)">ยกเลิก</v-btn>
              </v-stepper-content>

              <!-- ══════ STEP 7: ข้อมูลติดต่อ ══════ -->
              <v-stepper-step :complete="steps > 7" step="7"
                >ข้อมูลติดต่อ</v-stepper-step
              >
              <v-stepper-content step="7">
                <v-card class="pa-2">
                  <v-alert
                    border="left"
                    colored-border
                    type="error"
                    elevation="2"
                    v-if="!user.tel_p"
                    >กรุณาปรับปรุงข้อมูลยังหน้าผู้ใช้</v-alert
                  >
                  <v-alert
                    border="left"
                    colored-border
                    type="info"
                    elevation="2"
                    v-else
                  >
                    โทรศัพท์: {{ user.tel_p }} | E-mail: {{ user.e_mail }}
                  </v-alert>
                </v-card>
                <v-btn
                  @click="updatetransference_manageSubmit(7)"
                  color="primary"
                  >บันทึก</v-btn
                >
                <v-btn text @click="canceltransference(5)">ยกเลิก</v-btn>
              </v-stepper-content>

              <!-- ══════ STEP 8: ประวัติการรับราชการ ══════ -->
              <v-stepper-step :complete="steps > 8" step="8"
                >ประวัติการรับราชการ</v-stepper-step
              >
              <v-stepper-content step="8">
                <v-card>
                  <v-data-table
                    :headers="header_work"
                    :items="personnel_work_history"
                    class="elevation-1"
                  >
                    <template v-slot:item="{ index, item }">
                      <tr>
                        <td class="text-center">{{ index + 1 }}</td>
                        <td class="text-center">
                          {{
                            item.date_begin
                              | moment("add", "543 years")
                              | moment("D MMMM YYYY")
                          }}
                        </td>
                        <td class="text-center">{{ item.position_s }}</td>
                        <td class="text-center">
                          {{ item.college_name_work }}
                        </td>
                        <td></td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card>
                <v-btn
                  @click="updatetransference_manageSubmit(8)"
                  color="primary"
                  >บันทึก</v-btn
                >
                <v-btn text @click="canceltransference(6)">ยกเลิก</v-btn>
              </v-stepper-content>

              <!-- ══════ STEP 9: ลาศึกษาต่อ ══════ -->
              <v-stepper-step :complete="steps > 9" step="9"
                >อยู่ระหว่างลาศึกษาต่อเต็มเวลาหรือไม่</v-stepper-step
              >
              <v-stepper-content step="9">
                <v-card>
                  <v-row>
                    <v-col cols="12">
                      <v-alert
                        border="bottom"
                        colored-border
                        type="warning"
                        elevation="2"
                      >
                        <v-radio-group
                          row
                          v-model="transference_manages.manage_on_study_leave"
                        >
                          <v-radio value="no_leave"
                            ><template v-slot:label
                              ><strong class="primary--text"
                                >ไม่อยู่</strong
                              ></template
                            ></v-radio
                          >
                          <v-radio value="leave"
                            ><template v-slot:label
                              ><strong class="warning--text"
                                >อยู่</strong
                              ></template
                            ></v-radio
                          >
                        </v-radio-group>
                      </v-alert>
                    </v-col>
                    <v-col cols="12">
                      <v-card class="pa-2">
                        <v-row>
                          <v-col cols="12" sm="6">
                            <v-text-field
                              v-model="
                                transference_manages.manage_study_leave_location
                              "
                              :disabled="
                                transference_manages.manage_on_study_leave ===
                                  'no_leave'
                              "
                              outlined
                              label="ลาศึกษาต่อที่"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <v-text-field
                              v-model="
                                transference_manages.manage_study_leave_level
                              "
                              :disabled="
                                transference_manages.manage_on_study_leave ===
                                  'no_leave'
                              "
                              outlined
                              label="ระดับ"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <v-autocomplete
                              v-model="
                                transference_manages.manage_study_leave_college
                              "
                              outlined
                              :items="colleges"
                              item-text="college_name"
                              item-value="college_code"
                              label="สถานศึกษา"
                              :disabled="
                                transference_manages.manage_on_study_leave ===
                                  'no_leave'
                              "
                            />
                          </v-col>
                          <v-col cols="12" sm="3">
                            <v-dialog
                              ref="dialog_1"
                              v-model="modal_1"
                              :return-value.sync="date"
                              persistent
                              width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  outlined
                                  v-model="
                                    transference_manages.manage_study_leave_start
                                  "
                                  label="ตั้งแต่วันที่"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  :disabled="
                                    transference_manages.manage_on_study_leave ===
                                      'no_leave'
                                  "
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="
                                  transference_manages.manage_study_leave_start
                                "
                                scrollable
                                locale="th"
                              >
                                <v-spacer></v-spacer>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="modal_1 = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  text
                                  color="primary"
                                  @click="$refs.dialog_1.save(date)"
                                  >OK</v-btn
                                >
                              </v-date-picker>
                            </v-dialog>
                          </v-col>
                          <v-col cols="12" sm="3">
                            <v-dialog
                              ref="dialog_2"
                              v-model="modal_2"
                              :return-value.sync="date"
                              persistent
                              width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  outlined
                                  v-model="
                                    transference_manages.manage_study_leave_end
                                  "
                                  label="ถึงวันที่"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  :disabled="
                                    transference_manages.manage_on_study_leave ===
                                      'no_leave'
                                  "
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="
                                  transference_manages.manage_study_leave_end
                                "
                                scrollable
                                locale="th"
                              >
                                <v-spacer></v-spacer>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="modal_2 = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  text
                                  color="primary"
                                  @click="$refs.dialog_2.save(date)"
                                  >OK</v-btn
                                >
                              </v-date-picker>
                            </v-dialog>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card>
                <v-btn
                  @click="updatetransference_manageSubmit(9)"
                  color="primary"
                  >บันทึก</v-btn
                >
                <v-btn text @click="canceltransference(7)">ยกเลิก</v-btn>
              </v-stepper-content>

              <!-- ══════ STEP 10: ผลการปฏิบัติงาน ══════ -->
              <v-stepper-step :complete="steps > 10" step="10"
                >ข้อมูลอื่น ๆ</v-stepper-step
              >
              <v-stepper-content step="10">
                <v-card>
                  <v-textarea
                    v-model="transference_manages.manage_performance"
                    outlined
                    label="ผลการปฏิบัติงาน (ระบุ) *"
                  ></v-textarea>
                </v-card>
                <v-btn
                  @click="updatetransference_manageSubmit(10)"
                  color="primary"
                  >บันทึก</v-btn
                >
                <v-btn text @click="canceltransference(8)">ยกเลิก</v-btn>
              </v-stepper-content>

              <!-- ══════ STEP 11: วินัย ══════ -->
              <v-stepper-step :complete="steps > 11" step="11"
                >การรักษาวินัยและจรรยาบรรณ</v-stepper-step
              >
              <v-stepper-content step="11">
                <v-card>
                  <v-alert
                    border="bottom"
                    colored-border
                    type="warning"
                    elevation="2"
                  >
                    <h3>เคยถูกลงโทษทางวินัยหรือไม่</h3>
                    <v-radio-group
                      v-model="transference_manages.manage_disciplinary"
                    >
                      <v-radio value="no_discip"
                        ><template v-slot:label
                          ><strong class="primary--text"
                            >ไม่เคยถูกลงโทษทางวินัย</strong
                          ></template
                        ></v-radio
                      >
                      <v-radio value="discip">
                        <template v-slot:label>
                          <div>
                            <strong class="warning--text"
                              >เคยถูกลงโทษทางวินัย</strong
                            >
                            <v-checkbox
                              v-model="
                                transference_manages.manage_disciplinary_1
                              "
                              label="ภาคทัณ์"
                              value="1"
                              :disabled="
                                transference_manages.manage_disciplinary ===
                                  'no_discip'
                              "
                            ></v-checkbox>
                            <v-checkbox
                              v-model="
                                transference_manages.manage_disciplinary_2
                              "
                              label="ตัดเงินเดือน"
                              value="1"
                              :disabled="
                                transference_manages.manage_disciplinary ===
                                  'no_discip'
                              "
                            ></v-checkbox>
                            <v-checkbox
                              v-model="
                                transference_manages.manage_disciplinary_3
                              "
                              label="ลดเงินเดือน"
                              value="1"
                              :disabled="
                                transference_manages.manage_disciplinary ===
                                  'no_discip'
                              "
                            ></v-checkbox>
                          </div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-alert>
                </v-card>
                <v-btn
                  @click="updatetransference_manageSubmit(11)"
                  color="primary"
                  >บันทึก</v-btn
                >
                <v-btn text @click="canceltransference(9)">ยกเลิก</v-btn>
              </v-stepper-content>

              <!-- ══════ STEP 12: ใบประกอบวิชาชีพ ══════ -->
              <v-stepper-step :complete="steps > 12" step="12"
                >เคยถูกพิจารณาเกี่ยวกับใบประกอบวิชาชีพ</v-stepper-step
              >
              <v-stepper-content step="12">
                <v-card>
                  <v-radio-group v-model="transference_manages.manage_license">
                    <v-radio value="no_license"
                      ><template v-slot:label
                        ><strong class="primary--text">ไม่เคย</strong></template
                      ></v-radio
                    >
                    <v-radio value="license">
                      <template v-slot:label>
                        <div>
                          <strong class="warning--text">เคย</strong>
                          <v-checkbox
                            v-model="transference_manages.manage_license_1"
                            label="ตักเตือน"
                            value="1"
                            :disabled="
                              transference_manages.manage_license ===
                                'no_license'
                            "
                          ></v-checkbox>
                          <v-checkbox
                            v-model="transference_manages.manage_license_2"
                            label="ภาคทัณฑ์"
                            value="1"
                            :disabled="
                              transference_manages.manage_license ===
                                'no_license'
                            "
                          ></v-checkbox>
                          <v-checkbox
                            v-model="transference_manages.manage_license_3"
                            label="พักใช้ใบอนุญาต"
                            value="1"
                            :disabled="
                              transference_manages.manage_license ===
                                'no_license'
                            "
                          ></v-checkbox>
                          <v-checkbox
                            v-model="transference_manages.manage_license_4"
                            label="เพิกถอนใบอนุญาต"
                            value="1"
                            :disabled="
                              transference_manages.manage_license ===
                                'no_license'
                            "
                          ></v-checkbox>
                        </div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </v-card>
                <v-btn
                  @click="updatetransference_manageSubmit(12)"
                  color="primary"
                  >บันทึก</v-btn
                >
                <v-btn text @click="canceltransference(10)">ยกเลิก</v-btn>
              </v-stepper-content>

              <!-- ══════ STEP 13: ปริมาณงาน ══════ -->
              <v-stepper-step :complete="steps > 13" step="13"
                >ปริมาณงานหน่วยงานการศึกษาปัจจุบัน</v-stepper-step
              >
              <v-stepper-content step="13">
                <v-card>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="transference_manages.manage_personnel"
                        outlined
                        label="จำนวนบุคลากร (คน)"
                        prepend-icon="mdi-account-tie"
                        type="number"
                        min="0"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="transference_manages.manage_classroom"
                        outlined
                        label="จำนวนห้องเรียน (ห้อง)"
                        prepend-icon="mdi-door"
                        type="number"
                        min="0"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model.number="transference_manages.manage_std_vc"
                        outlined
                        label="ปวช. (คน)"
                        prepend-icon="mdi-account-group"
                        type="number"
                        min="0"
                        @input="calculateTotalStudents()"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model.number="transference_manages.manage_std_hvc"
                        outlined
                        label="ปวส. (คน)"
                        prepend-icon="mdi-account-group"
                        type="number"
                        min="0"
                        @input="calculateTotalStudents()"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model.number="transference_manages.manage_std_sc"
                        outlined
                        label="ระยะสั้น (คน)"
                        prepend-icon="mdi-account-group"
                        type="number"
                        min="0"
                        @input="calculateTotalStudents()"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-alert type="info" outlined class="text-center">
                        <h2>
                          จำนวนนักเรียนรวม:
                          <strong class="primary--text">{{
                            transference_manages.manage_std_all || 0
                          }}</strong>
                          คน
                        </h2>
                        <span
                          >(ปวช. {{ transference_manages.manage_std_vc || 0 }} +
                          ปวส. {{ transference_manages.manage_std_hvc || 0 }} +
                          ระยะสั้น
                          {{ transference_manages.manage_std_sc || 0 }})</span
                        >
                      </v-alert>
                    </v-col>
                  </v-row>
                </v-card>
                <v-btn
                  @click="updatetransference_manageSubmit(13)"
                  color="primary"
                  >บันทึก</v-btn
                >
                <v-btn text @click="canceltransference(11)">ยกเลิก</v-btn>
              </v-stepper-content>

              <!-- ══════ STEP 14: ช่วยปฏิบัติราชการ ══════ -->
              <v-stepper-step :complete="steps > 14" step="14"
                >อยู่ระหว่างช่วยปฏิบัติราชการหรือไม่</v-stepper-step
              >
              <v-stepper-content step="14">
                <v-row>
                  <v-col cols="12">
                    <v-alert
                      border="bottom"
                      colored-border
                      type="warning"
                      elevation="2"
                    >
                      <v-radio-group
                        row
                        v-model="transference_manages.manage_service_status"
                      >
                        <v-radio value="not_service"
                          ><template v-slot:label
                            ><strong class="primary--text"
                              >ไม่อยู่</strong
                            ></template
                          ></v-radio
                        >
                        <v-radio value="gov_service"
                          ><template v-slot:label
                            ><strong class="warning--text"
                              >ช่วยปฏิบัติราชการ</strong
                            ></template
                          ></v-radio
                        >
                      </v-radio-group>
                    </v-alert>
                  </v-col>
                  <v-col cols="12">
                    <v-card class="pa-2">
                      <v-row>
                        <v-col cols="12" sm="6">
                          <v-autocomplete
                            v-model="
                              transference_manages.manage_service_college
                            "
                            outlined
                            :items="colleges"
                            item-text="college_name"
                            item-value="college_code"
                            label="ช่วยปฏิบัติราชการที่"
                            prepend-icon="mdi-office-building-marker"
                            :disabled="
                              transference_manages.manage_service_status ===
                                'not_service'
                            "
                          />
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-dialog
                            ref="dialog_3"
                            v-model="modal_3"
                            :return-value.sync="date"
                            persistent
                            width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                outlined
                                v-model="
                                  transference_manages.manage_service_datetime
                                "
                                label="ตั้งแต่วันที่"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                :disabled="
                                  transference_manages.manage_service_status ===
                                    'not_service'
                                "
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="
                                transference_manages.manage_service_datetime
                              "
                              scrollable
                              locale="th"
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="modal_3 = false"
                                >Cancel</v-btn
                              >
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.dialog_3.save(date)"
                                >OK</v-btn
                              >
                            </v-date-picker>
                          </v-dialog>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
                <v-btn
                  @click="updatetransference_manageSubmit(14)"
                  color="primary"
                  >บันทึก</v-btn
                >
                <v-btn text @click="canceltransference(12)">ยกเลิก</v-btn>
              </v-stepper-content>

              <!-- ══════ STEP 15: กรณีย้าย ══════ -->
              <v-stepper-step :complete="steps > 15" step="15"
                >ขอย้ายกรณี</v-stepper-step
              >
              <v-stepper-content step="15">
                <v-card>
                  <v-row>
                    <v-col cols="12">
                      <v-alert
                        border="bottom"
                        colored-border
                        type="warning"
                        elevation="2"
                      >
                        <v-radio-group
                          row
                          v-model="transference_manages.manage_case_move"
                        >
                          <v-radio value="normal"
                            ><template v-slot:label
                              ><strong
                                class="primary--text"
                                @click="clearCasemove()"
                                >ปกติ</strong
                              ></template
                            ></v-radio
                          >
                          <v-radio value="special"
                            ><template v-slot:label
                              ><strong class="warning--text"
                                >พิเศษ</strong
                              ></template
                            ></v-radio
                          >
                        </v-radio-group>
                      </v-alert>
                    </v-col>
                    <!-- กรณีปกติ -->
                    <v-col
                      cols="12"
                      v-if="transference_manages.manage_case_move === 'normal'"
                    >
                      <v-card class="pa-2">
                        <v-card-title
                          ><v-icon large left>mdi-account-details</v-icon>
                          เหตุผลการขอย้าย กรณีปกติ</v-card-title
                        >
                        <v-card-text>
                          <v-row align="center">
                            <v-card-title
                              >ย้ายเพื่ออยู่ร่วมคู่สมรส</v-card-title
                            >
                            <v-checkbox
                              v-model="transference_manages.manage_reason_1"
                              value="1"
                              hide-details
                              class="shrink mr-2 mt-0"
                            ></v-checkbox>
                            <v-text-field
                              v-model="
                                transference_manages.manage_reason_1_spouse
                              "
                              :disabled="!transference_manages.manage_reason_1"
                              label="ชื่อคู่สมรส"
                            ></v-text-field>
                            <v-text-field
                              v-model="
                                transference_manages.manage_reason_1_occupation
                              "
                              :disabled="!transference_manages.manage_reason_1"
                              label="อาชีพคู่สมรส"
                            ></v-text-field>
                            <v-text-field
                              v-model="
                                transference_manages.manage_reason_1_location
                              "
                              :disabled="!transference_manages.manage_reason_1"
                              label="สถานที่ประกอบอาชีพ"
                            ></v-text-field>
                            <v-autocomplete
                              v-model="
                                transference_manages.manage_reason_1_domicile
                              "
                              :items="provices_sh"
                              item-text="province_name"
                              item-value="province_ID"
                              :disabled="!transference_manages.manage_reason_1"
                              label="ภูมิลำเนาคู่สมรส จังหวัด"
                            ></v-autocomplete>
                          </v-row>
                          <v-row align="center">
                            <v-card-title>ย้ายเพื่อดูแลบิดา มารดา</v-card-title>
                            <v-checkbox
                              v-model="transference_manages.manage_reason_2"
                              value="1"
                              hide-details
                              class="shrink mr-2 mt-0"
                            ></v-checkbox>
                            <v-autocomplete
                              :items="manage_reason_2_years"
                              item-text="text"
                              item-value="value"
                              v-model="
                                transference_manages.manage_reason_2_fyear
                              "
                              :disabled="!transference_manages.manage_reason_2"
                              label="อายุบิดา ปี"
                            ></v-autocomplete>
                            <v-autocomplete
                              :items="manage_reason_2_years"
                              item-text="text"
                              item-value="value"
                              v-model="
                                transference_manages.manage_reason_2_myear
                              "
                              :disabled="!transference_manages.manage_reason_2"
                              label="อายุมารดา ปี"
                            ></v-autocomplete>
                            <v-autocomplete
                              v-model="
                                transference_manages.manage_reason_2_domicile
                              "
                              :items="provices_sh"
                              item-text="province_name"
                              item-value="province_ID"
                              :disabled="!transference_manages.manage_reason_2"
                              label="ภูมิลำเนาบิดา มารดา จังหวัด"
                            ></v-autocomplete>
                          </v-row>
                          <v-row align="center">
                            <v-card-title>ย้ายกลับภูมิลำเนา</v-card-title>
                            <v-checkbox
                              v-model="transference_manages.manage_reason_3"
                              value="1"
                              hide-details
                              class="shrink mr-2 mt-0"
                            ></v-checkbox>
                            <v-autocomplete
                              v-model="
                                transference_manages.manage_reason_3_domicile
                              "
                              :items="provices_sh"
                              item-text="province_name"
                              item-value="province_ID"
                              :disabled="!transference_manages.manage_reason_3"
                              label="ภูมิลำเนา จังหวัด"
                            ></v-autocomplete>
                          </v-row>
                          <v-row align="center">
                            <v-card-title>เหตุผลอื่น</v-card-title>
                            <v-checkbox
                              v-model="transference_manages.manage_reason_4"
                              value="1"
                              hide-details
                              class="shrink mr-2 mt-0"
                            ></v-checkbox>
                            <v-textarea
                              v-model="
                                transference_manages.manage_reason_4_detail
                              "
                              :disabled="!transference_manages.manage_reason_4"
                              label="(ระบุ)"
                            ></v-textarea>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <!-- กรณีพิเศษ -->
                    <v-col
                      cols="12"
                      v-if="transference_manages.manage_case_move === 'special'"
                    >
                      <v-card class="pa-2">
                        <v-card-title
                          ><v-icon large left>mdi-account-details</v-icon>
                          เหตุผลการขอย้าย กรณีพิเศษ</v-card-title
                        >
                        <v-card-text>
                          <v-row align="center">
                            <v-card-title
                              >ย้ายเพื่อติดตามคู่สมรส
                              เจ็บป่วยร้ายแรง</v-card-title
                            >
                            <v-checkbox
                              v-model="transference_manages.manage_reason_1_sp"
                              value="1"
                              hide-details
                              class="shrink mr-2 mt-0"
                            ></v-checkbox>
                            <v-text-field
                              v-model="
                                transference_manages.manage_reason_1_sp_case
                              "
                              :disabled="
                                !transference_manages.manage_reason_1_sp
                              "
                              label="เนื่องจาก"
                            ></v-text-field>
                          </v-row>
                          <v-row align="center">
                            <v-card-title
                              >ย้ายเพื่อดูแลบิดามารดา/คู่สมรส/บุตร
                              เจ็บป่วยร้ายแรง/ทุพพลภาพ</v-card-title
                            >
                            <v-checkbox
                              v-model="transference_manages.manage_reason_2_sp"
                              value="1"
                              hide-details
                              class="shrink mr-2 mt-0"
                            ></v-checkbox>
                            <v-text-field
                              v-model="
                                transference_manages.manage_reason_2_sp_case
                              "
                              :disabled="
                                !transference_manages.manage_reason_2_sp
                              "
                              label="เนื่องจาก"
                            ></v-text-field>
                          </v-row>
                          <v-row align="center">
                            <v-card-title>ถูกคุกคามต่อชีวิต</v-card-title>
                            <v-checkbox
                              v-model="transference_manages.manage_reason_3_sp"
                              value="1"
                              hide-details
                              class="shrink mr-2 mt-0"
                            ></v-checkbox>
                            <v-text-field
                              v-model="
                                transference_manages.manage_reason_3_case
                              "
                              :disabled="
                                !transference_manages.manage_reason_3_sp
                              "
                              label="รายละเอียด"
                            ></v-text-field>
                          </v-row>
                          <v-row>
                            <v-textarea
                              v-model="transference_manages.manage_case_detail"
                              outlined
                              rows="2"
                              label="พิเศษ กรณีอื่น ๆ"
                            ></v-textarea>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card>
                <v-btn
                  @click="updatetransference_manageSubmit(15)"
                  color="primary"
                  >บันทึก</v-btn
                >
                <v-btn text @click="canceltransference(13)">ยกเลิก</v-btn>
              </v-stepper-content>

              <!-- ══════ STEP 16: เลือกหน่วยงาน ══════ -->
              <v-stepper-step :complete="steps > 16" step="16">
                ข้าพเจ้าประสงค์ขอย้ายไปดำรงตำแหน่งที่
                <v-chip
                  color="red"
                  dark
                  small
                  v-if="transference_manage_locations.length === 0"
                  class="ml-2"
                  >* เลือกอย่างน้อย 1 แห่ง</v-chip
                >
              </v-stepper-step>
              <v-stepper-content step="16">
                <v-card class="pa-2">
                  <v-row>
                    <v-col cols="12">
                      <v-btn
                        x-large
                        color="success"
                        dark
                        rounded
                        @click.stop="
                          addtransference_manage_locationdialogsubmit()
                        "
                      >
                        <v-icon>mdi-selection-multiple-marker</v-icon>
                        เลือกหน่วยงานแห่งใหม่
                      </v-btn>
                      <v-alert
                        type="warning"
                        outlined
                        class="mt-3"
                        v-if="transference_manage_locations.length === 0"
                      >
                        <v-icon left>mdi-alert</v-icon>
                        กรุณาเลือกหน่วยงานที่ประสงค์ขอย้ายอย่างน้อย 1 แห่ง
                      </v-alert>
                      <v-data-table
                        :headers="header_trans"
                        :items="transference_manage_locations"
                      >
                        <template v-slot:item.action="{ item }">
                          <v-icon
                            color="red"
                            @click.stop="
                              transference_manage_locationDelete(
                                item.manage_location_id_tfl
                              )
                            "
                            >mdi-delete</v-icon
                          >
                        </template>
                      </v-data-table>
                    </v-col>
                    <v-col cols="12">
                      <v-card class="pa-2">
                        <v-card-title>ถ้าไม่ได้ตามที่ระบุ</v-card-title>
                        <v-row>
                          <v-col cols="12">
                            <v-alert
                              border="bottom"
                              colored-border
                              type="warning"
                              elevation="2"
                            >
                              <v-radio-group
                                row
                                v-model="transference_manages.manage_move_if"
                              >
                                <v-radio value="suspend"
                                  ><template v-slot:label
                                    ><strong
                                      class="primary--text"
                                      @click="clear_gov_service()"
                                      >ขอระงับการย้าย</strong
                                    ></template
                                  ></v-radio
                                >
                                <v-radio value="another"
                                  ><template v-slot:label
                                    ><strong class="warning--text"
                                      >หน่วยงานการศึกษาใดก็ได้ใน</strong
                                    ></template
                                  ></v-radio
                                >
                              </v-radio-group>
                            </v-alert>
                          </v-col>
                          <v-col cols="12">
                            <v-autocomplete
                              v-model="
                                transference_manages.manage_move_if_detail
                              "
                              :items="provices_sh"
                              item-text="province_name"
                              item-value="province_ID"
                              outlined
                              prepend-icon="mdi-office-building-marker"
                              label="สอจ. :"
                              :disabled="
                                transference_manages.manage_move_if ===
                                  'suspend'
                              "
                            ></v-autocomplete>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-col>
                    <v-col cols="12">
                      <h3>
                        ขอย้ายสับเปลี่ยนกับ: {{ personnel_temporarys.title_s }}
                        {{ personnel_temporarys.frist_name }}
                        {{ personnel_temporarys.last_name }}
                      </h3>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        v-model="transference_manages.manage_switch_position"
                        :counter="13"
                        outlined
                        label="บัตรประชาชน (สับเปลี่ยน)"
                        prepend-icon="mdi-account-details"
                        v-on:keyup.enter="OnEnter()"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field
                        :value="personnel_temporarys.position_name"
                        outlined
                        label="ตำแหน่ง"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field
                        :value="personnel_temporarys.rang_name"
                        outlined
                        label="วิทยฐานะ"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" class="caption"
                      >* กรณีย้ายสับเปลี่ยน ให้กรอกเลขบัตรประชาชนแล้วกด
                      Enter</v-col
                    >
                  </v-row>
                </v-card>
                <v-btn @click="validateAndSaveStep16()" color="primary"
                  >บันทึก</v-btn
                >
                <v-btn text @click="canceltransference(14)">ยกเลิก</v-btn>
              </v-stepper-content>

              <!-- ══════ STEP 17: หลักฐาน ══════ -->
              <v-stepper-step :complete="steps > 17" step="17"
                >หลักฐานประกอบการพิจารณา</v-stepper-step
              >
              <v-stepper-content step="17">
                <v-card>
                  <v-row class="pa-4">
                    <v-col cols="12" sm="4"
                      ><v-checkbox
                        v-model="transference_manages.manage_evidence_info_1"
                        value="1"
                        label="สำเนา กพ.7/ก.ค.ศ.16"
                      ></v-checkbox
                    ></v-col>
                    <v-col cols="12" sm="4"
                      ><v-checkbox
                        v-model="transference_manages.manage_evidence_info_2"
                        value="1"
                        label="สำเนาทะเบียนบ้าน"
                      ></v-checkbox
                    ></v-col>
                    <v-col cols="12" sm="4"
                      ><v-checkbox
                        v-model="transference_manages.manage_evidence_info_3"
                        value="1"
                        label="สำเนาใบสำคัญสมรส"
                      ></v-checkbox
                    ></v-col>
                    <v-col cols="12" sm="4"
                      ><v-checkbox
                        v-model="transference_manages.manage_evidence_info_4"
                        value="1"
                        label="ใบรับรองแพทย์"
                      ></v-checkbox
                    ></v-col>
                    <v-col cols="12" sm="4"
                      ><v-checkbox
                        v-model="transference_manages.manage_evidence_info_5"
                        value="1"
                        label="บันทึกประจำวัน ตำรวจ/ปกครอง"
                      ></v-checkbox
                    ></v-col>
                    <v-col cols="12" sm="4"
                      ><v-checkbox
                        v-model="transference_manages.manage_evidence_info_6"
                        value="1"
                        label="บันทึกข้อตกลงผู้ขอสับเปลี่ยน"
                      ></v-checkbox
                    ></v-col>
                    <v-col cols="12" sm="4"
                      ><v-checkbox
                        v-model="transference_manages.manage_evidence_info_7"
                        value="1"
                        label="วิสัยทัศน์การบริหารจัดการศึกษา"
                      ></v-checkbox
                    ></v-col>
                    <v-col cols="12" sm="8">
                      <v-row align="center">
                        <v-card-title>อื่นๆ</v-card-title>
                        <v-checkbox
                          v-model="transference_manages.manage_evidence_info_8"
                          value="1"
                          hide-details
                          class="shrink mr-2 mt-0"
                        ></v-checkbox>
                        <v-textarea
                          outlined
                          v-model="
                            transference_manages.manage_evidence_info_8_detail
                          "
                          :disabled="
                            !transference_manages.manage_evidence_info_8
                          "
                          label="(ระบุ)"
                        ></v-textarea>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>
                <v-btn
                  @click="updatetransference_manageSubmit(17)"
                  color="primary"
                  >บันทึก</v-btn
                >
                <v-btn text @click="canceltransference(15)">ยกเลิก</v-btn>
              </v-stepper-content>

              <!-- ══════ STEP 18: เหตุผลอื่นๆ ══════ -->
              <v-stepper-step :complete="steps > 18" step="18"
                >เหตุผลการขอย้าย อื่นๆ เพิ่มเติม</v-stepper-step
              >
              <v-stepper-content step="18">
                <v-card>
                  <v-textarea
                    outlined
                    v-model="transference_manages.manage_reason_detail"
                    label="(ระบุ)"
                  ></v-textarea>
                </v-card>
                <v-btn
                  @click="updatetransference_manageSubmit(18)"
                  color="primary"
                  >บันทึก</v-btn
                >
                <v-btn text @click="canceltransference(16)">ยกเลิก</v-btn>
              </v-stepper-content>

              <!-- ══════════════════════════════════════════════════════════
                   STEP 19: แนบไฟล์
                   อนุญาตเฉพาะตอน file_open = true
                   ══════════════════════════════════════════════════════════ -->
              <v-stepper-step :complete="steps > 19" step="19">
                <div>
                  แนบไฟล์แบบคำร้องประสงค์ย้าย
                  <v-chip
                    v-if="transference_manages.manage_file_attachment"
                    color="green"
                    dark
                    small
                    class="ml-2"
                  >
                    <v-icon left small>mdi-check</v-icon> แนบไฟล์แล้ว
                  </v-chip>
                  <v-chip
                    v-if="periodStatus && !periodStatus.file_open"
                    color="red"
                    dark
                    small
                    class="ml-2"
                  >
                    <v-icon left small>mdi-clock-alert</v-icon> หมดเวลาแนบไฟล์
                  </v-chip>
                </div>
              </v-stepper-step>
              <v-stepper-content step="19">
                <v-card class="pa-4">
                  <v-row>
                    <v-col cols="12">
                      <!-- แนบไฟล์ได้: file_open = true -->
                      <v-alert
                        v-if="periodStatus && periodStatus.file_open"
                        type="warning"
                        outlined
                      >
                        <h3>
                          กรุณาอัปโหลดแบบคำร้องขอย้ายที่ลงนามเรียบร้อยแล้ว
                        </h3>
                        <p>รองรับ PDF, JPG, PNG ขนาดไม่เกิน 10 MB</p>
                        <p>
                          <v-chip color="orange" dark small>
                            <v-icon left small>mdi-calendar</v-icon>
                            แนบได้ถึง
                            {{ periodStatus.period_stop_file | thaiDate }}
                          </v-chip>
                        </p>
                      </v-alert>
                      <!-- หมดเวลาแนบ: file_open = false -->
                      <v-alert v-else type="error" outlined>
                        <h3>
                          <v-icon left>mdi-clock-alert</v-icon>
                          หมดเวลาการแนบไฟล์แล้ว
                        </h3>
                        <p>ไม่สามารถแนบหรือเปลี่ยนไฟล์ได้อีก</p>
                      </v-alert>
                    </v-col>

                    <!-- ─── ปุ่มพิมพ์ (พิมพ์ได้เสมอ) ─────────────── -->
                    <v-col cols="12" md="6">
                      <v-btn
                        x-large
                        color="info"
                        dark
                        class="ma-2"
                        @click="openPrintDialog()"
                      >
                        <v-icon left>mdi-printer</v-icon>
                        พิมพ์แบบแสดงความประสงค์
                      </v-btn>
                    </v-col>

                    <!-- ─── File Input (เฉพาะ file_open) ─────────── -->
                    <v-col
                      cols="12"
                      md="6"
                      v-if="periodStatus && periodStatus.file_open"
                    >
                      <v-file-input
                        v-model="fileAttachment"
                        label="เลือกไฟล์แบบคำร้อง"
                        outlined
                        accept=".pdf,.jpg,.jpeg,.png"
                        prepend-icon="mdi-paperclip"
                        show-size
                      ></v-file-input>
                    </v-col>

                    <!-- ─── แสดงไฟล์ที่แนบแล้ว ─────────────────── -->
                    <v-col
                      cols="12"
                      v-if="transference_manages.manage_file_attachment"
                    >
                      <v-alert type="success" outlined>
                        <v-icon left>mdi-file-check</v-icon>
                        ไฟล์ที่แนบ:
                        {{ transference_manages.manage_file_attachment }}<br />
                        วันที่แนบ:
                        {{ transference_manages.manage_file_attachment_date }}
                      </v-alert>
                    </v-col>
                  </v-row>
                </v-card>

                <!-- ─── ปุ่มอัปโหลด (เฉพาะ file_open) ─────────── -->
                <v-btn
                  v-if="periodStatus && periodStatus.file_open"
                  @click="uploadFileAttachment()"
                  color="primary"
                  :loading="uploading"
                  :disabled="!fileAttachment"
                  class="mr-2"
                >
                  <v-icon left>mdi-upload</v-icon> อัปโหลดไฟล์
                </v-btn>

                <!-- ยกเลิกรายการ -->
                <v-btn

                  color="red"
                  @click="canceltransference(17)"
                  v-if="periodStatus && periodStatus.file_open"
                  >ยกเลิกรายการ</v-btn
                >*การยกเลิกรายการ เป็นเพียงการย้อนกลับไปยังขั้นตอนก่อนหน้านี้ 
                <!-- ─── ข้ามได้เฉพาะแนบไฟล์แล้ว ─────────────── -->
                <v-btn
                  text
                  @click="steps = 20"
                  v-if="transference_manages.manage_file_attachment"
                  >ไปขั้นต่อไป</v-btn
                >

                <!-- ─── ข้ามได้เลยถ้า file_open = false ──────── -->
                <v-btn
                  text
                  @click="steps = 20"
                  v-if="periodStatus && !periodStatus.file_open"
                  >ดำเนินการต่อ (ไม่ต้องแนบไฟล์)</v-btn
                >
              </v-stepper-content>

              <!-- ══════ STEP 20: ตรวจสอบและยืนยัน ══════ -->
              <v-stepper-step :complete="steps > 20" step="20"
                >ตรวจสอบและยืนยันการยื่นคำร้อง</v-stepper-step
              >
              <v-stepper-content step="20">
                <v-card class="pa-4 mb-4">
                  <v-row>
                    <v-col cols="12" md="6">
                      <h3>แบบแสดงความประสงค์ขอย้าย</h3>
                      <iframe
                        style="width:100%;height:400px;border:1px solid #ddd;border-radius:8px;"
                        :src="
                          '#/user/print_info_manage/?manage_id_ref=' +
                            manage_id_ref
                        "
                      ></iframe>
                      <div class="text-center mt-3">
                        <v-btn
                          outlined
                          color="primary"
                          target="_blank"
                          :href="
                            '#/user/print_info_manage/?manage_id_ref=' +
                              manage_id_ref
                          "
                        >
                          <v-icon left>mdi-open-in-new</v-icon> เปิดเต็มจอ
                        </v-btn>
                      </div>
                    </v-col>
                    <v-col cols="12" md="6">
                      <h3>ไฟล์แนบแบบคำร้อง</h3>
                      <div v-if="transference_manages.manage_file_attachment">
                        <p>
                          <strong>ไฟล์:</strong>
                          {{ transference_manages.manage_file_attachment
                          }}<br />
                          <strong>วันที่แนบ:</strong>
                          {{ transference_manages.manage_file_attachment_date }}
                        </p>
                        <iframe
                          style="width:100%;height:400px;border:1px solid #ddd;border-radius:8px;"
                          :src="
                            '/uploads/transference_manage/' +
                              transference_manages.manage_file_attachment
                          "
                        ></iframe>
                        <div class="text-center mt-3">
                          <v-btn
                            outlined
                            color="info"
                            target="_blank"
                            :href="
                              '/uploads/transference_manage/' +
                                transference_manages.manage_file_attachment
                            "
                          >
                            <v-icon left>mdi-file-pdf-box</v-icon> เปิดดูเต็มจอ
                          </v-btn>
                        </div>
                      </div>
                      <div v-else>
                        <v-alert type="warning" outlined class="mt-4">
                          <v-icon left>mdi-alert</v-icon>
                          ยังไม่มีไฟล์แนบแบบคำร้อง
                          <span v-if="periodStatus && periodStatus.file_open">
                            — กลับไป Step 19 เพื่อแนบไฟล์
                          </span>
                          <span v-else>
                            (หมดเวลาแนบไฟล์แล้ว สามารถยืนยันได้โดยไม่มีไฟล์)
                          </span>
                        </v-alert>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
                <v-btn
                  @click="submitTransference()"
                  color="success"
                  x-large
                  :loading="submitting"
                >
                  <v-icon left>mdi-check-circle</v-icon>
                  ยืนยันการยื่นคำร้องขอย้าย
                </v-btn>
                <v-btn text large @click="steps = 19">ย้อนกลับ</v-btn>
              </v-stepper-content>
            </v-stepper>
          </v-card>
        </base-material-card>
      </v-col>
    </v-row>

    <!-- ══════ Dialogs ══════ -->

    <!-- Dialog: เลือกวิทยาลัย -->
    <v-dialog
      v-model="addtransference_manage_locationdialog"
      persistent
      max-width="60%"
    >
      <v-card class="mx-auto pa-5">
        <base-material-card
          icon="mdi-account-multiple"
          title="เลือกวิทยาลัย"
          class="px-5 py-3"
        >
          รหัสรายการอ้างอิง {{ manage_id_ref }}
        </base-material-card>
        <v-card-text>
          <v-form ref="addtransference_manage_locationform" lazy-validation>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex md2>
                  <v-select
                    v-model="
                      addtransference_manage_location.manage_location_sequence_n
                    "
                    :items="order_need"
                    outlined
                    label="ลำดับที่"
                  ></v-select>
                </v-flex>
                <v-flex md10>
                  <v-autocomplete
                    v-model="
                      addtransference_manage_location.manage_location_college_code
                    "
                    :items="colleges"
                    item-text="college_name"
                    item-value="college_code"
                    outlined
                    label="สังกัด"
                    prepend-icon="mdi-flag-letiant"
                    :rules="[v => !!v || '']"
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="warning"
            large
            @click.stop="addtransference_manage_locationdialog = false"
            ><v-icon>mdi-close</v-icon> ยกเลิก</v-btn
          >
          <v-btn
            large
            color="success"
            @click.stop="addtransference_manage_locationSubmit()"
            ><v-icon>mdi-content-save</v-icon> บันทึก</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog: ลบรายการ -->
    <v-dialog
      v-model="delettransference_manage_locationdialog"
      persistent
      max-width="40%"
    >
      <v-card class="mx-auto pa-5">
        <base-material-card
          color="error"
          icon="mdi-delete"
          title="ลบรายการ"
          class="px-5 py-3"
        ></base-material-card>
        <v-card-text>
          <v-form ref="deletetransference_manage_locationform" lazy-validation>
            <v-container
              ><v-layout wrap
                ><v-flex xs12
                  >ยืนยันการลบ
                  <strong>{{
                    edittransference_manage_location.college_name
                  }}</strong></v-flex
                ></v-layout
              ></v-container
            >
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            large
            @click.stop="delettransference_manage_locationdialog = false"
            ><v-icon>mdi-close</v-icon> ยกเลิก</v-btn
          >
          <v-btn
            large
            color="red darken-3"
            dark
            @click.stop="deletetransference_manage_locationSubmit()"
            ><v-icon>mdi-delete</v-icon> ลบ</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ══════════════════════════════════════════════════════════════
         Dialog: ยกเลิก/รีเซ็ตรายการด้วยตนเอง
         - ข้อมูลเดิมยังคงอยู่ แค่ reset กลับ step 1
         - แสดงปุ่มได้เฉพาะ isPeriodOpen = true
         ══════════════════════════════════════════════════════════════ -->
    <v-dialog v-model="cancelSelfDialog" persistent max-width="55%">
      <v-card class="mx-auto pa-5">
        <base-material-card
          color="warning"
          icon="mdi-backup-restore"
          title="ยกเลิกการยืนยัน และแก้ไขรายการ"
          class="px-5 py-3"
        ></base-material-card>

        <v-card-text>
          <!-- ─── ชี้แจงว่า "ไม่ลบ" ─────────────────────────── -->
          <v-alert type="info" outlined prominent class="mb-3">
            <h3>
              <v-icon left color="blue">mdi-information</v-icon>
              ข้อมูลเดิมของท่านจะยังคงอยู่
            </h3>
            <p class="mb-0">
              ระบบจะ<strong>รีเซ็ตสถานะ</strong>กลับไปที่ขั้นตอนที่ 1
              ท่านสามารถตรวจสอบและแก้ไขข้อมูลได้ทันที
              โดยไม่ต้องกรอกใหม่ตั้งแต่ต้น
            </p>
          </v-alert>

          <!-- ─── สรุปข้อมูลปัจจุบัน ─────────────────────────── -->
          <v-card outlined class="mb-3">
            <v-card-title class="subtitle-2 pb-1">
              <v-icon left small>mdi-file-document-outline</v-icon>
              ข้อมูลรายการปัจจุบัน
            </v-card-title>
            <v-card-text class="pt-0">
              <v-row dense>
                <v-col cols="6" sm="4">
                  <span class="caption grey--text">รหัสอ้างอิง</span><br />
                  <strong>{{ manage_id_ref }}</strong>
                </v-col>
                <v-col cols="6" sm="4">
                  <span class="caption grey--text">สถานะเดิม</span><br />
                  <v-chip x-small color="green" dark>
                    {{ transference_manages.manage_status_save }}
                  </v-chip>
                </v-col>
                <v-col cols="6" sm="4">
                  <span class="caption grey--text">หน่วยงานที่เลือก</span><br />
                  <strong
                    >{{ transference_manage_locations.length }} แห่ง</strong
                  >
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  v-if="transference_manages.manage_file_attachment"
                >
                  <span class="caption grey--text">ไฟล์แนบ</span><br />
                  <v-chip x-small color="indigo" dark>
                    <v-icon left x-small>mdi-paperclip</v-icon>
                    {{ transference_manages.manage_file_attachment }}
                  </v-chip>
                  <span class="caption ml-1 grey--text"
                    >(ไฟล์แนบยังคงอยู่)</span
                  >
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- ─── เหตุผล ──────────────────────────────────────── -->
          <v-form ref="cancelForm">
            <v-textarea
              v-model="cancelReason"
              outlined
              label="เหตุผลในการขอแก้ไข / รีเซ็ต *"
              :rules="[v => !!v || 'กรุณาระบุเหตุผล']"
              rows="3"
              prepend-icon="mdi-comment-edit-outline"
              hint="เหตุผลจะถูกบันทึกเป็น Log ไว้อ้างอิง"
              persistent-hint
            ></v-textarea>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn large rounded @click="cancelSelfDialog = false">
            <v-icon>mdi-close</v-icon> ปิด
          </v-btn>
          <v-btn
            large
            color="warning"
            dark
            rounded
            @click="confirmCancelSelf()"
            :loading="cancelLoading"
          >
            <v-icon left>mdi-backup-restore</v-icon>
            รีเซ็ต และกลับไปแก้ไข
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog: พิมพ์แบบคำร้อง (พิมพ์ได้เสมอ) -->
    <v-dialog v-model="printDialog" width="80%">
      <v-card>
        <v-card-title>
          แบบแสดงความประสงค์ขอย้าย
          <v-spacer></v-spacer>
          <v-btn icon @click="printDialog = false"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-card-title>
        <v-card-text>
          <iframe
            style="width:100%;height:600px;border:none;"
            :src="'#/user/print_info_manage/?manage_id_ref=' + manage_id_ref"
          ></iframe>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="printDialog = false">ปิด</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog: Preview -->
    <v-dialog v-model="previewReport" width="80%">
      <v-card>
        <v-card-title>
          ตัวอย่างแบบแสดงความประสงค์
          <v-spacer></v-spacer>
          <v-btn icon @click="previewReport = false"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-card-title>
        <iframe
          style="width:100%;height:600px;"
          :src="
            '#/user/print_info_manage_preview/?manage_id_ref=' + manage_id_ref
          "
        ></iframe>
      </v-card>
    </v-dialog>

    <!-- Dialog: ดูไฟล์แนบ -->
    <v-dialog v-model="fileAttachmentDialog" width="80%">
      <v-card>
        <v-card-title>
          ไฟล์แนบ
          <v-spacer></v-spacer>
          <v-btn icon @click="fileAttachmentDialog = false"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-card-title>
        <v-card-text>
          <iframe
            style="width:100%;height:600px;border:none;"
            :src="'/uploads/transference_manage/' + fileAttachmentUrl"
          ></iframe>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <v-snackbar
      v-model="snackbar.show"
      top
      :timeout="snackbar.timeout"
      :color="snackbar.color"
    >
      <v-icon large>{{ snackbar.icon }}</v-icon>
      <v-card-text>{{ snackbar.text }}</v-card-text>
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">Close</v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  name: "HrvecTransferencePersonnel",

  filters: {
    /**
     * แปลง YYYY-MM-DD → DD/MM/พ.ศ.
     */
    thaiDate(val) {
      if (!val) return "-";
      try {
        const d = new Date(val);
        const dd = String(d.getDate()).padStart(2, "0");
        const mm = String(d.getMonth() + 1).padStart(2, "0");
        const yy = d.getFullYear() + 543;
        return `${dd}/${mm}/${yy}`;
      } catch {
        return val;
      }
    }
  },

  data() {
    return {
      loading: true,
      ApiKey: "HRvec2021",
      localTime: "",
      colleges: [],
      provices_sh: [],
      user: {},
      transference_manages: {},
      transference_manage_locations: [],
      addtransference_manage: {
        manage_on_study_leave: "no_leave",
        manage_disciplinary: "no_discip",
        manage_license: "no_license",
        manage_case_move: "normal",
        manage_move_if: "suspend",
        manage_switch_position: "-",
        manage_service_status: "not_service"
      },
      addtransference_manage_location: {},
      edittransference_manage_location: [],
      personnel_educations: [],
      personnel_education_check: [],
      personnel_work_history: [],
      personnel_work_history_check: [],
      personnel_temporarys: [],
      periods: {},

      // ── สถานะระบบ (3 ระดับ) ──────────────────────────
      /** ผลจาก period_status.php */
      periodStatus: null,

      steps: 1,
      previewReport: false,
      printDialog: false,
      fileAttachmentDialog: false,
      fileAttachmentUrl: "",
      showFileUploadPanel: false,

      // File upload
      fileAttachment: null,
      uploading: false,
      submitting: false,

      // ยกเลิกด้วยตนเอง
      cancelSelfDialog: false,
      cancelReason: "",
      cancelLoading: false,

      // Date pickers
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      modal_1: false,
      modal_2: false,
      modal_3: false,

      snackbar: { show: false, color: "", timeout: 5000, icon: "", text: "" },
      order_need: [1, 2, 3],

      header_trans: [
        { text: "ลำดับ", align: "center", value: "manage_location_sequence_n" },
        {
          text: "รหัสอ้างอิง",
          align: "center",
          value: "manage_location_id_ref"
        },
        { text: "ตำแหน่ง", align: "center", value: "manage_location_position" },
        { text: "วิทยาลัย", align: "center", value: "college_name" },
        { text: "ยกเลิก", align: "center", value: "action" }
      ],
      header_work: [
        { text: "ลำดับ", align: "center", value: "index" },
        { text: "วันเดือนปี", align: "center", value: "date_begin" },
        { text: "ตำแหน่ง/ระดับ", align: "center", value: "position_s" },
        { text: "สังกัด", align: "center", value: "college_code" },
        { text: "หมายเหตุ", align: "center", value: "action" }
      ],

      manage_reason_2_years: [
        { text: "เสียชีวิต", value: "เสียชีวิต" },
        ...Array.from({ length: 108 }, (_, i) => ({
          text: String(30 + i),
          value: String(30 + i)
        }))
      ],

      transference_manage_location_update: {}
    };
  },

  // ─────────────────────────────────────────────────────────────────────
  async mounted() {
    const userSession = JSON.parse(sessionStorage.getItem("user")) || {};

    const [r_prov, r_col, r_user] = await Promise.all([
      this.$http.post("province_sh.php", { ApiKey: this.ApiKey }),
      this.$http.post("college.php", { ApiKey: this.ApiKey }),
      this.$http.post("personnel_temporary.php", {
        ApiKey: this.ApiKey,
        id_card: userSession.id_card
      })
    ]);
    this.provices_sh = r_prov.data;
    this.colleges = r_col.data;
    this.user = r_user.data;

    await this.periodQuery();
    await this.loadPeriodStatus(); // ← โหลดสถานะ 3 ระดับ
    await this.transference_manageAll();
    await this.transference_manage_locationQueryAll();
    await this.personnel_educationsQueryAll();
    await this.personnel_educations_checkQueryAll();
    await this.personnel_work_historyQueryAll();
    await this.personnel_work_historyCheck();
    await this.personnel_temporarysQueryAll();
    this.showLocaleTime();
  },

  // ─────────────────────────────────────────────────────────────────────
  computed: {
    user_status_type() {
      const us = this.user.user_status;
      if (us === "teacher") return "teacher";
      if (us === "director" || us === "se_director") return "manage";
      return "manage";
    },

    manage_id_ref() {
      return (
        "M" +
        this.periods.period_times +
        "" +
        parseInt(this.periods.period_year) +
        "" +
        this.user.id_card
      );
    },

    /**
     * isPeriodOpen: true เมื่อ period_enable=1 และยังอยู่ในช่วง period_stop
     */
    isPeriodOpen() {
      return !!(this.periodStatus && this.periodStatus.period_open);
    },

    systemStatusBannerType() {
      if (!this.periodStatus) return "info";
      if (this.periodStatus.period_open) return "success";
      if (this.periodStatus.file_open) return "warning";
      return "error";
    },

    marital_status() {
      const map = {
        single: "โสด",
        married: "สมรส",
        widow: "หม้าย",
        divorce: "หย่า",
        separate: "แยกกันอยู่"
      };
      return map[this.user.marital_status] || "";
    },

    date_today() {
      const t = new Date();
      return (
        String(t.getDate()).padStart(2, "0") +
        "/" +
        String(t.getMonth() + 1).padStart(2, "0") +
        "/" +
        (t.getFullYear() + 543)
      );
    },

    date_today_cal() {
      const t = new Date();
      return (
        t.getFullYear() +
        "-" +
        String(t.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(t.getDate()).padStart(2, "0")
      );
    },

    date_month_cal() {
      if (!this.periods || !this.periods.period_cal_end) return null;
      return new Date(this.periods.period_cal_end);
    },

    date_appoin_ch() {
      const months = [
        "",
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม"
      ];
      return (
        this.user.appoin_day +
        " " +
        months[parseInt(this.user.appoin_month)] +
        " " +
        parseInt(this.user.appoin_year)
      );
    },

    get_Age() {
      return this._calcAge(
        new Date(this.date_today_cal),
        new Date(
          parseInt(this.user.brith_year) -
            543 +
            "-" +
            this.user.brith_month +
            "-" +
            this.user.brith_day
        )
      );
    },
    get_Appoint_Age() {
      return this._calcAge(
        new Date(this.date_month_cal),
        new Date(this.user.date_app_now)
      );
    },
    get_gov_Age() {
      return this._calcAge(
        new Date(this.date_today_cal),
        new Date(
          parseInt(this.user.appoin_year) -
            543 +
            "-" +
            this.user.appoin_month +
            "-" +
            this.user.appoin_day
        )
      );
    },

    get_gov_Age_year() {
      if (!this.date_month_cal || !this.user.date_app_now) return 0;
      const today = new Date(this.date_month_cal);
      const DOB = new Date(this.user.date_app_now);
      if (isNaN(today) || isNaN(DOB)) return 0;
      let years = today.getFullYear() - DOB.getFullYear();
      if (
        DOB.getMonth() > today.getMonth() ||
        (DOB.getMonth() === today.getMonth() && DOB.getDate() > today.getDate())
      )
        years--;
      return years;
    }
  },

  // ─────────────────────────────────────────────────────────────────────
  methods: {
    // ══════════════════════════════════════════════════════════════════
    // loadPeriodStatus: โหลดสถานะ 3 ระดับจาก period_status.php
    // ══════════════════════════════════════════════════════════════════
    async loadPeriodStatus() {
      try {
        const r = await this.$http.post("period_status.php", {
          ApiKey: this.ApiKey,
          period_type: this.user_status_type
        });
        this.periodStatus = r.data;
      } catch (e) {
        console.error("loadPeriodStatus error:", e);
        this.periodStatus = {
          period_open: false,
          file_open: false,
          print_open: true
        };
      }
    },

    // ══════════════════════════════════════════════════════════════════
    // transference_manageAll: โหลดข้อมูลและตัดสินใจว่าแสดง step ไหน
    // ══════════════════════════════════════════════════════════════════
    async transference_manageAll() {
      this.loading = true;
      const r = await this.$http
        .post("transference_manage.php", {
          ApiKey: this.ApiKey,
          manage_id_ref: this.manage_id_ref
        })
        .finally(() => (this.loading = false));

      this.transference_manages = r.data || {};

      const stepsep = this.transference_manages.manage_status_save;
      if (stepsep === "Save" || stepsep === "Confirm") {
        // รายการยืนยันแล้ว — step ไม่มีผล (Zone A จะแสดง)
        this.steps = 20;
      } else if (stepsep === "Cancel" || !stepsep) {
        this.steps = 1;
      } else if (!isNaN(parseInt(stepsep))) {
        this.steps = parseInt(stepsep) + 1;
      } else {
        this.steps = 1;
      }

      // รีเฟรชสถานะระบบทุกครั้งที่โหลดข้อมูล
      await this.loadPeriodStatus();
    },

    // ══════════════════════════════════════════════════════════════════
    // periodQuery: ดึง period สำหรับ manage_id_ref / ตรวจสอบสิทธิ์
    // ══════════════════════════════════════════════════════════════════
    async periodQuery() {
      const r = await this.$http.post("period.php", {
        ApiKey: this.ApiKey,
        period_enable: "OK",
        period_type: this.user_status_type
      });
      this.periods = r.data;

      // ตรวจสอบสิทธิ์ระยะเวลาปฏิบัติงาน
      if (this.get_gov_Age_year < 2) {
        this.$router.push("/UserProfile");
        Swal.fire({
          icon: "error",
          title: "ผู้ขอย้ายดำรงตำแหน่งในสถานศึกษาปัจจุบันไม่น้อยกว่า 24 เดือน",
          allowOutsideClick: false
        }).then(() => this.$router.push("/UserProfile"));
      }
    },

    // ══════════════════════════════════════════════════════════════════
    // submitTransference: ขั้นตอนสุดท้าย ยืนยัน Confirm
    // ══════════════════════════════════════════════════════════════════
    async submitTransference() {
      // ตรวจสอบ period_open อีกครั้ง
      await this.loadPeriodStatus();
      if (!this.isPeriodOpen) {
        Swal.fire({ icon: "error", title: "ระบบปิดรับการยื่นย้ายแล้ว" });
        return;
      }

      this.submitting = true;
      try {
        const r = await this.$http.post("transference_manage.update.php", {
          ApiKey: this.ApiKey,
          manage_id_ref: this.manage_id_ref,
          manage_id_card: this.user.id_card,
          manage_status_save: "Confirm"
        });
        if (r.data.status) {
          await this.saveLog(
            "submit_final",
            20,
            "ยืนยันยื่นคำร้องขอย้ายสมบูรณ์"
          );
          Swal.fire({
            icon: "success",
            title: "ยื่นคำร้องขอย้ายเสร็จสมบูรณ์!"
          }).then(() => this.transference_manageAll());
        } else {
          Swal.fire({
            icon: "error",
            title: "เกิดข้อผิดพลาดในการยืนยันข้อมูล"
          });
        }
      } catch (e) {
        Swal.fire({ icon: "error", title: "ระบบขัดข้อง" });
      }
      this.submitting = false;
    },

    // ══════════════════════════════════════════════════════════════════
    // uploadFileAttachment: อัปโหลดไฟล์แบบคำร้อง
    // ══════════════════════════════════════════════════════════════════
    async uploadFileAttachment() {
      if (!this.fileAttachment) {
        Swal.fire({ icon: "warning", title: "กรุณาเลือกไฟล์" });
        return;
      }
      if (this.fileAttachment.size > 10 * 1024 * 1024) {
        Swal.fire({
          icon: "warning",
          title: "ไฟล์มีขนาดใหญ่เกินไป (สูงสุด 10MB)"
        });
        return;
      }

      // ตรวจ file_open อีกครั้งก่อนส่ง
      await this.loadPeriodStatus();
      if (!this.periodStatus.file_open) {
        Swal.fire({ icon: "error", title: "หมดเวลาแนบไฟล์แล้ว" });
        return;
      }

      this.uploading = true;
      try {
        const formData = new FormData();
        formData.append("ApiKey", this.ApiKey);
        formData.append("manage_id_ref", this.manage_id_ref);
        formData.append("manage_id_card", this.user.id_card);
        formData.append("period_type", this.user_status_type);
        formData.append("manage_file", this.fileAttachment);

        const r = await this.$http.post(
          "transference_manage_file_upload.php",
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" }
          }
        );

        if (r.data.status) {
          await this.saveLog(
            "upload_file",
            19,
            "อัปโหลดไฟล์: " + r.data.filename
          );
          this.showFileUploadPanel = false;
          this.fileAttachment = null;
          Swal.fire({
            icon: "success",
            title: "อัปโหลดไฟล์สำเร็จ",
            showConfirmButton: false,
            timer: 1500
          });
          await this.transference_manageAll();
          // ถ้าอยู่ใน stepper ให้ไป step 20
          if (this.steps === 19) this.steps = 20;
        } else {
          Swal.fire({
            icon: "error",
            title: r.data.message || "อัปโหลดไฟล์ผิดพลาด"
          });
        }
      } catch (e) {
        Swal.fire({ icon: "error", title: "เกิดข้อผิดพลาดในการอัปโหลด" });
      }
      this.uploading = false;
    },

    // ══════════════════════════════════════════════════════════════════
    // showCancelDialog / confirmCancelSelf
    // reset กลับ step 1 โดย "ไม่ลบ" ข้อมูลเดิม
    // ══════════════════════════════════════════════════════════════════
    showCancelDialog() {
      this.cancelReason = "";
      this.cancelSelfDialog = true;
    },

    async confirmCancelSelf() {
      if (!this.$refs.cancelForm.validate()) return;
      this.cancelLoading = true;
      try {
        const r = await this.$http.post("transference_manage_cancel.php", {
          ApiKey: this.ApiKey,
          manage_id_ref: this.manage_id_ref,
          manage_id_card: this.user.id_card,
          manage_cancel_reason: this.cancelReason,
          log_ip_address: "",
          log_user_agent: navigator.userAgent
        });
        if (r.data.status) {
          this.cancelSelfDialog = false;
          // โหลดข้อมูลใหม่ก่อน แล้วค่อยกระโดด step
          await this.transference_manageAll();
          this.steps = 2;
          Swal.fire({
            icon: "success",
            title: "รีเซ็ตรายการเรียบร้อย",
            html: "ข้อมูลเดิมของท่านยังคงอยู่<br/>กรุณาตรวจสอบและยืนยันใหม่",
            confirmButtonText: "เริ่มตรวจสอบ"
          });
        } else {
          Swal.fire({
            icon: "error",
            title: r.data.message || "ไม่สามารถรีเซ็ตได้"
          });
        }
      } catch (e) {
        Swal.fire({ icon: "error", title: "เกิดข้อผิดพลาด" });
      }
      this.cancelLoading = false;
    },

    resetAndStartNew() {
      this.transference_manages = {};
      this.steps = 1;
    },

    openPrintDialog() {
      this.printDialog = true;
    },
    previewReportShow() {
      this.previewReport = true;
    },

    previewFile(url) {
      this.fileAttachmentUrl = url;
      this.fileAttachmentDialog = true;
    },

    // ── Validation Step 16 ──────────────────────────────────────────
    async validateAndSaveStep16() {
      if (this.transference_manage_locations.length === 0) {
        Swal.fire({
          icon: "warning",
          title: "กรุณาเลือกหน่วยงานอย่างน้อย 1 แห่ง"
        });
        return;
      }
      await this.updatetransference_manageSubmit(16);
    },

    // ── คำนวณนักเรียนรวม ─────────────────────────────────────────────
    calculateTotalStudents() {
      const vc = parseInt(this.transference_manages.manage_std_vc) || 0;
      const hvc = parseInt(this.transference_manages.manage_std_hvc) || 0;
      const sc = parseInt(this.transference_manages.manage_std_sc) || 0;
      this.transference_manages.manage_std_all = vc + hvc + sc;
    },

    // ── บันทึก Log ────────────────────────────────────────────────────
    async saveLog(action, step, detail) {
      try {
        await this.$http.post("transference_manage_log.insert.php", {
          ApiKey: this.ApiKey,
          log_manage_id_ref: this.manage_id_ref,
          log_id_card: this.user.id_card,
          log_action: action,
          log_step: String(step),
          log_detail: detail,
          log_ip_address: "",
          log_user_agent: navigator.userAgent
        });
      } catch (e) {
        /* silent */
      }
    },

    clearCasemove() {
      this.transference_manages.manage_reason_1_sp = false;
      this.transference_manages.manage_reason_2_sp = false;
      this.transference_manages.manage_reason_3_sp = false;
    },

    clear_gov_service() {
      this.transference_manages.manage_move_if_detail = "";
    },

    showLocaleTime() {
      setInterval(() => {
        this.localTime = new Date().toLocaleTimeString();
      }, 1000);
    },

    // ══════════════════════════════════════════════════════════════════
    // updatetransference_manageSubmit
    // ══════════════════════════════════════════════════════════════════
    async updatetransference_manageSubmit(step) {
      // ── Validation ──────────────────────────────────────────────────
      const validations = {
        2: [
          this.transference_manages.manage_knowledge,
          "กรุณากรอกความรู้ความสามารถ"
        ],
        3: [this.transference_manages.manage_experience, "กรุณากรอกประสบการณ์"],
        5: [
          this.transference_manages.manage_address_now,
          "กรุณากรอกที่อยู่ปัจจุบัน"
        ],
        6: [
          this.transference_manages.manage_after_move,
          "กรุณากรอกที่อยู่เมื่อย้ายแล้ว"
        ],
        10: [
          this.transference_manages.manage_performance,
          "กรุณากรอกผลการปฏิบัติงาน"
        ]
      };
      if (validations[step] && !validations[step][0]) {
        Swal.fire({ icon: "warning", title: validations[step][1] });
        return;
      }

      if (step === 13) this.calculateTotalStudents();

      this.transference_manages.ApiKey = this.ApiKey;
      this.transference_manages.manage_age_app_time = String(
        this.get_Appoint_Age
      );
      this.transference_manages.manage_year_age = String(this.get_Age);
      this.transference_manages.manage_age_time = String(this.get_gov_Age);
      this.transference_manages.manage_status_save = step;

      // Reset checkbox
      [
        "manage_reason_1",
        "manage_reason_2",
        "manage_reason_3",
        "manage_reason_4",
        "manage_reason_1_sp",
        "manage_reason_2_sp",
        "manage_reason_3_sp",
        "manage_evidence_info_1",
        "manage_evidence_info_2",
        "manage_evidence_info_3",
        "manage_evidence_info_4",
        "manage_evidence_info_5",
        "manage_evidence_info_6",
        "manage_evidence_info_7",
        "manage_evidence_info_8"
      ].forEach(f => {
        if (this.transference_manages[f] != 1) this.transference_manages[f] = 0;
      });

      // ── Step 19 = ขั้นสุดท้ายก่อน Confirm ────────────────────────
      if (step === 19) {
        this.transference_manages.manage_status_save = "Save";
        this.transference_manage_location_update.ApiKey = this.ApiKey;
        this.transference_manage_location_update.manage_location_id_ref = this.transference_manages.manage_id_ref;
        this.transference_manage_location_update.manage_location_status_confirm =
          "Save";

        const confirm = await Swal.fire({
          title: "ขั้นตอนสุดท้าย: เมื่อยืนยันจะไม่สามารถแก้ไขข้อมูลหลักได้",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก"
        });
        if (!confirm.isConfirmed) return;

        const [r1, r2] = await Promise.all([
          this.$http.post(
            "transference_manage.update.php",
            this.transference_manages
          ),
          this.$http.post(
            "transference_manage_location.update.php",
            this.transference_manage_location_update
          )
        ]);
        if (r1.data.status || r2.data.status) {
          await this.saveLog(
            "save_final",
            step,
            "บันทึกรายการย้ายสำเร็จ ก่อน Confirm"
          );
          await this.transference_manageAll();
          Swal.fire({
            icon: "success",
            title: "บันทึกเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
        } else {
          Swal.fire({ icon: "warning", title: "ดำเนินการผิดพลาด" });
        }
        return;
      }

      // ── Step ทั่วไป ──────────────────────────────────────────────
      const r = await this.$http.post(
        "transference_manage.update.php",
        this.transference_manages
      );
      if (r.data.status) {
        await this.saveLog("update", step, "บันทึกขั้นตอนที่ " + step);
        await this.transference_manageAll();
        Swal.fire({
          icon: "success",
          title: "บันทึกเรียบร้อย",
          showConfirmButton: false,
          timer: 1500
        });
      } else {
        Swal.fire({ icon: "warning", title: "ดำเนินการผิดพลาด" });
      }
    },

    // ══════════════════════════════════════════════════════════════════
    // addtransference_manageSubmit: สร้างรายการใหม่
    // ══════════════════════════════════════════════════════════════════
    async addtransference_manageSubmit(steps) {
      const confirm = await Swal.fire({
        title: "ประสงค์ทำรายการยื่นย้าย",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก"
      });
      if (!confirm.isConfirmed) return;

      this.addtransference_manage.ApiKey = this.ApiKey;
      this.addtransference_manage.manage_id_ref = this.manage_id_ref;
      this.addtransference_manage.manage_time_s = this.periods.period_times;
      this.addtransference_manage.manage_year_s = this.periods.period_year;
      this.addtransference_manage.manage_year_age = String(this.get_Age);
      this.addtransference_manage.manage_year_budget = this.periods.period_year;
      this.addtransference_manage.manage_id_card = this.user.id_card;
      this.addtransference_manage.manage_date_time = this.date_today;
      this.addtransference_manage.manage_age_app_time = String(
        this.get_Appoint_Age
      );
      this.addtransference_manage.manage_age_time = String(this.get_gov_Age);
      this.addtransference_manage.manage_college_code_now = this.user.college_code;
      this.addtransference_manage.manage_status_save = steps;

      const r = await this.$http.post(
        "transference_manage.insert.php",
        this.addtransference_manage
      );
      if (r.data.status) {
        await this.saveLog("insert", steps, "สร้างรายการย้ายใหม่");
        Swal.fire({
          icon: "success",
          title: "ดำเนินการเรียบร้อย",
          showConfirmButton: false,
          timer: 1500
        });
        this.transference_manageAll();
      } else {
        Swal.fire({ icon: "warning", title: "ดำเนินการผิดพลาด" });
      }
    },

    // ══════════════════════════════════════════════════════════════════
    // canceltransference: ย้อนกลับ step หรือลบรายการ
    // ══════════════════════════════════════════════════════════════════
    async canceltransference(step) {
      if (step === 2) {
        const confirm = await Swal.fire({
          title: "ต้องการยกเลิกรายการยื่นย้ายครั้งนี้?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก"
        });
        if (!confirm.isConfirmed) return;

        this.transference_manages.ApiKey = this.ApiKey;
        this.transference_manage_location_update.ApiKey = this.ApiKey;
        this.transference_manage_location_update.manage_location_id_ref = this.transference_manages.manage_id_ref;

        const [r1, r2] = await Promise.all([
          this.$http.post(
            "transference_manage.delete.php",
            this.transference_manages
          ),
          this.$http.post(
            "transference_manage_location.delete.cancel.php",
            this.transference_manage_location_update
          )
        ]);
        if (r1.data.status || r2.data.status) {
          await this.saveLog("cancel", step, "ยกเลิกรายการย้ายทั้งหมด");
          Swal.fire({
            icon: "success",
            title: "ดำเนินการเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          this.transference_manageAll();
        } else {
          Swal.fire({ icon: "warning", title: "ดำเนินการผิดพลาด" });
        }
      } else {
        this.transference_manages.ApiKey = this.ApiKey;
        this.transference_manages.manage_age_app_time = String(
          this.get_Appoint_Age
        );
        this.transference_manages.manage_year_age = String(this.get_Age);
        this.transference_manages.manage_age_time = String(this.get_gov_Age);
        this.transference_manages.manage_status_save = step;

        const r = await this.$http.post(
          "transference_manage.update.php",
          this.transference_manages
        );
        if (r.data.status) {
          Swal.fire({
            icon: "success",
            title: "ดำเนินการเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          this.transference_manageAll();
        } else {
          Swal.fire({ icon: "warning", title: "ดำเนินการผิดพลาด" });
        }
      }
    },

    // ══════════════════════════════════════════════════════════════════
    // Location methods
    // ══════════════════════════════════════════════════════════════════
    async transference_manage_locationQueryAll() {
      const r = await this.$http.post("transference_manage_location.php", {
        ApiKey: this.ApiKey,
        manage_location_id_ref: this.manage_id_ref
      });
      this.transference_manage_locations = r.data;
    },

    async addtransference_manage_locationdialogsubmit() {
      this.addtransference_manage_location = {};
      this.addtransference_manage_locationdialog = true;
    },

    async addtransference_manage_locationSubmit() {
      if (this.$refs.addtransference_manage_locationform.validate()) {
        this.addtransference_manage_location.ApiKey = this.ApiKey;
        this.addtransference_manage_location.manage_location_id_ref = this.manage_id_ref;
        this.addtransference_manage_location.manage_location_id_card = this.user.id_card;
        this.addtransference_manage_location.manage_location_position = this.user.position_name;

        const r = await this.$http.post(
          "transference_manage_location.insert.php",
          this.addtransference_manage_location
        );
        if (r.data.status) {
          Swal.fire({
            icon: "success",
            title: "บันทึกเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          this.transference_manage_locationQueryAll();
        } else {
          this.snackbar = {
            show: true,
            icon: "mdi-close-network",
            color: "red",
            text: "ลำดับหรือหน่วยงานซ้ำ",
            timeout: 5000
          };
        }
        this.addtransference_manage_locationdialog = false;
      }
    },

    async transference_manage_locationDelete(id) {
      const r = await this.$http.post("transference_manage_location.php", {
        ApiKey: this.ApiKey,
        manage_location_id_tfl: id
      });
      this.edittransference_manage_location = r.data;
      this.delettransference_manage_locationdialog = true;
    },

    async deletetransference_manage_locationSubmit() {
      if (this.$refs.deletetransference_manage_locationform.validate()) {
        this.edittransference_manage_location.ApiKey = this.ApiKey;
        const r = await this.$http.post(
          "transference_manage_location.delete.php",
          this.edittransference_manage_location
        );
        if (r.data.status) {
          Swal.fire({
            icon: "success",
            title: "ลบเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          this.transference_manage_locationQueryAll();
        } else {
          Swal.fire({ icon: "warning", title: "ลบผิดพลาด" });
        }
        this.delettransference_manage_locationdialog = false;
      }
    },

    async personnel_temporarysQueryAll() {
      const r = await this.$http.post("personnel_temporary.php", {
        ApiKey: this.ApiKey,
        id_card: this.transference_manages.manage_switch_position
      });
      this.personnel_temporarys = r.data;
    },

    async OnEnter() {
      const id =
        this.transference_manages.manage_switch_position ||
        this.addtransference_manage.manage_switch_position;
      const r = await this.$http.post("personnel_temporary.php", {
        ApiKey: this.ApiKey,
        id_card: id
      });
      this.personnel_temporarys = r.data;
    },

    async personnel_work_historyQueryAll() {
      const us = JSON.parse(sessionStorage.getItem("user")) || {};
      const r = await this.$http
        .post("personnel_work_history.php", {
          ApiKey: this.ApiKey,
          id_card: us.id_card
        })
        .finally(() => (this.loading = false));
      this.personnel_work_history = r.data;
    },

    async personnel_work_historyCheck() {
      const us = JSON.parse(sessionStorage.getItem("user")) || {};
      const r = await this.$http
        .post("personnel_work_history.php", {
          ApiKey: this.ApiKey,
          id_card: us.id_card,
          count_check: "Ok"
        })
        .finally(() => (this.loading = false));
      this.personnel_work_history_check = r.data;
    },

    async personnel_educationsQueryAll() {
      const us = JSON.parse(sessionStorage.getItem("user")) || {};
      const r = await this.$http
        .post("personnel_education.php", {
          ApiKey: this.ApiKey,
          id_card: us.id_card
        })
        .finally(() => (this.loading = false));
      this.personnel_educations = r.data;
    },

    async personnel_educations_checkQueryAll() {
      const us = JSON.parse(sessionStorage.getItem("user")) || {};
      const r = await this.$http
        .post("personnel_education.check.php", {
          ApiKey: this.ApiKey,
          id_card: us.id_card
        })
        .finally(() => (this.loading = false));
      this.personnel_education_check = r.data;
    },

    // ── Helper คำนวณอายุ ──────────────────────────────────────────────
    _calcAge(today, DOB) {
      const result = {
        years: 0,
        months: 0,
        days: 0,
        toString() {
          return (
            (this.years ? this.years + " ปี " : "") +
            (this.months ? this.months + " เดือน " : "") +
            (this.days ? this.days + " วัน" : "")
          );
        }
      };
      if (!today || !DOB || isNaN(today) || isNaN(DOB)) return result;

      result.months =
        today.getFullYear() * 12 +
        (today.getMonth() + 1) -
        (DOB.getFullYear() * 12 + (DOB.getMonth() + 1));
      if (0 > (result.days = today.getDate() - DOB.getDate())) {
        const m = (today.getMonth() - 1 + 12) % 12;
        result.days +=
          [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][m] +
          (m === 1 &&
          today.getFullYear() % 4 === 0 &&
          (today.getFullYear() % 100 > 0 || today.getFullYear() % 400 === 0)
            ? 1
            : 0);
        result.months--;
      }
      result.years = Math.floor(result.months / 12);
      result.months = result.months % 12;
      return result;
    }
  }
};
</script>

<style lang="scss" scoped></style>
